<div *ngIf="isShow" class="itc-page">

  <div class="row">
    <div class="col-md-10">
      <div class="container mb-4 p-0 mr-0 itc-page-toolbar">
        <div class="col-12 col-sm-4">
          <span class="itc-page-title">Income Tax Certificate</span>
        </div>
        <div class="col-12 col-sm-8">
        </div>
      </div>
    </div>
  </div>
  <div ngxUiLoaderBlurred class="row p-1">
    <div class="col-md-10 mb-5">
      <div class="container return-view-background mr-0 itc-certificate-wrap" style="height: 100%;background: white !important;">
        <div class="row">
          <div class="bg-white p-1 col-md-12 itc-certificate" style="border: none" id="income-tax-certificate">
            <div class="col-md-12 m-0" style="border: none">
              <div class="d-flex justify-content-between align-items-center col-12 px-2 mb-4">
                <div class="itc-ereturn-logo">
                  <img src="assets\img\logo\eReturn_logo_png.png" alt="Logo">
                </div>
                <div class="itc-reference">
                  <p>Reference Number: {{returnResponse?.referenceNo}}</p>
                </div>
              </div>
              <!-- <div class="itc-ereturn-logo">
                <img src="assets\img\logo\eReturn_logo_png.png" alt="Logo">
              </div>
              <div class="itc-reference">
                <p>Reference Number: {{returnResponse?.referenceNo}}</p>
              </div> -->
              <table class="table table-borderless">
                <tr>
                  <td class="text-center">
                    <img class="itc-govt-logo" src="assets/img/govt-logo/bd-govt-logo.png" alt="Logo">
                  </td>
                </tr>
                <tr>
                  <td class="text-center p-0">
                    <p class="m-0">Government of the People’s Republic of Bangladesh
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="text-center p-0">
                    <p class="m-0">National Board of Revenue</p>
                  </td>
                </tr>
                <tr>
                  <td class="text-center p-0">
                    <p class="m-0">Income Tax Department</p>
                  </td>
                </tr>
                <tr class="itc-header-spacer">

                </tr>
                <tr>
                  <td class="text-center p-0">
                    <p class="m-0">Income Tax Certificate</p>
                  </td>
                </tr>
                <tr>
                  <td class="text-center p-0">
                    <p class="m-0">Assessment Year: {{this.returnResponse?.assessmentYear}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="text-center pt-1">
                    <p class="itc-section-line mt-3 mb-0">
                      Section: {{ section?.value }} [{{ section?.label }}]
                    </p>
                  </td>
                </tr>
              </table>
              <div class="row m-0 itc-section">
                <div class="col-sm-2"></div>
                <div class="col-sm-8 mr-0 pr-0">
                  <table class="table table-borderless itc-details-table">
                    <tr>
                      <td class="py-0" width="50%">Taxpayer’s Name</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.assesName}}</td>
                    </tr>
                    <tr class="mt-1">
                      <td class="py-0" width="50%">Taxpayer’s Identification Number (TIN)</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.tin}}</td>
                    </tr>
                    <tr>
                      <td class="py-0" width="50%">Father’s Name</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.fathersName}}</td>
                    </tr>
                    <tr>
                      <td class="py-0" width="50%">Mother’s Name</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.mothersName}}</td>
                    </tr>
                    <tr>
                      <td class="py-0" width="50%">Current Address</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.presentAddress}}</td>
                    </tr>

                    <tr>
                      <td class="py-0" width="50%">Permanent Address</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.permanentAddress}}</td>
                    </tr>
                    <tr>
                      <td class="py-0" width="50%">Status</td>
                      <td class="py-0 text-center" width="5%">:</td>
                      <td class="py-0" width="45%">{{this.returnResponse?.status}}</td>
                    </tr>
                  </table>
                </div>
                <div class="col-sm-2 mr-0 pr-0"></div>
                
              </div>
              <div class="row m-2 itc-section">
                <div class="col-sm-2"></div>
                <div class="col-sm-8">
                  <p class="text-justify">This is to certify that {{this.returnResponse?.assesName}} is a registered taxpayer of Taxes
                    {{this.returnResponse?.circle}}, Taxes Zone-{{this.returnResponse?.zone}}. The taxpayer has filed the return of income for the Assessment Year {{this.returnResponse?.assessmentYear}}.<span
                    >{{getMessage()}}</span></p>
                    

                    
                    
                    </div>
                <div class="col-sm-2"></div>
              </div>
              
              <div class="row mt-4 text-center itc-qr">
                <div class="col-12 text-center">
                  <qrcode [elementType]="elementType" [qrdata]="taxpayerQRData" [width]="125" [errorCorrectionLevel]="'M'"></qrcode>
                </div>
              </div>

              <div class="row m-0 itc-section">
                <div class="col-sm-2"></div>
                <div class="col-sm-8 text-center">
                  <p>This is a system generated certificate, and requires no signature.</p>
                </div>
                <div class="col-sm-2"></div>
              </div>
            </div>
          </div>

        </div>
        
        <div class="row itc-download-row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8"></div>
          <div class="col-sm-2">
              
              
              <button type="button"
              class="btn btn-sm bg-white btn-pill rounded-pill btn-outline-dark btn-customize itc-download-btn"
              [printStyle]="{body : {'background': 'white'}}" [useExistingCss]="true" printTitle="Tax-Certificate-{{userTin}}" printSectionId="income-tax-certificate" ngxPrint>
              <i class="fa fa-print mr-1" aria-hidden="true"></i>
              <b>Download</b></button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 d-flex justify-content-start align-items-center m-0 p-0 itc-criteria-col" *ngIf="!isPublicUrl">
      <div class="col-auto px-3 py-4 bb bl bt br itc-criteria">
        <h6 class="mb-3">Please choose a criteria for a custom certificate:</h6>
        <div class="form-check mb-2">
          <input class="input-checkbox form-check-input" type="checkbox" id="checkBox1" [(ngModel)]="incomeCheckBox" (change)="onChangeCheckBox()">
          <label class="form-check-label ml-2 pt-1" for="checkBox1">Total Income</label>
        </div>
        <div class="form-check mb-2">
          <input class="input-checkbox form-check-input" type="checkbox" id="checkBox2" [(ngModel)]="netCheckBox" (change)="onChangeCheckBox()">
          <label class="form-check-label ml-2 pt-1" for="checkBox2">Net Wealth</label>
        </div>
        <div class="form-check">
          <input class="input-checkbox form-check-input" type="checkbox" id="checkBox3" [(ngModel)]="taxCheckBox" (change)="onChangeCheckBox()">
          <label class="form-check-label ml-2 pt-1" for="checkBox3">Paid Tax</label>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="!isShow && isPublicUrl && !isApiLoading" class="ack-empty-state">
  <div class="ack-empty-state__card">
    <div class="ack-empty-state__icon">
      <i class="fa fa-file-text-o" aria-hidden="true"></i>
    </div>
    <h3 class="ack-empty-state__title">No data found for this TIN</h3>
    <p class="ack-empty-state__subtitle">
      We could not find a tax certificate for the provided reference.
    </p>
  </div>
</div>
<ng-template #nullStatusModal>
  <div class="modal-body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="col-12 my-3">
      Have you submitted your return in Circle Office? If yes, then you can request for tax certificate.
    </div>
    <div class="col-12 text-center mb-3 mt-4">
      <button class="btn" style="background-color: #145DA0;color: white; width:200px"
        (click)="showTaxInfoModal('none')">
        Request
      </button>
    </div>
  </div>
</ng-template>

<ng-template #pendingStatusModal>
  <div class="modal-body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="col-12 my-3">
      Your return submission has not been approved yet by Circle Office. You can request for approval.
    </div>
    <div class="col-12 text-center mt-4 mb-3">
      <button class="btn" style="background-color: #145DA0;color: white; width:200px"
          (click)="showTaxInfoModal('pending')">
        Request for approval
      </button>
    </div>
  </div>
</ng-template>

<ng-template #infoMismatchModal>
  <div class="modal-body">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="col-12 my-3">
      Provided data doesn't match with your submitted return data! Request DCT to review your data?
    </div>
    <div class="col-12 text-center mt-4 mb-3">
      <button class="btn" style="background-color: #145DA0;color: white; width:200px"
          (click)="showTaxInfoModal('mismatched')">
        Request for Review
      </button>
    </div>
  </div>
</ng-template>

<ng-template #taxInfoModal>
  <div class="modal-header">
    <div class="col-12 font-weight-bold">
      Provide your tax information
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="taxInfoForm" class="container">
      <div class="form-group row">
        <label class="col-4">Total Income</label>
        <div class="input-group col-8">
          <input placeholder="" formControlName="totalIncome" class="form-control" (input)="filterCharacter($event,'totalIncome')"
            [ngClass]="{'is-invalid': taxInfoForm.get('totalIncome').touched && taxInfoForm.get('totalIncome').invalid}"
          >
          <div class="invalid-feedback">
            Total income is required
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4">Net Wealth</label>
        <div class="input-group col-8">
          <input placeholder="" formControlName="netWealth" class="form-control" (input)="filterCharacter($event,'netWealth')"
            [ngClass]="{'is-invalid': taxInfoForm.get('netWealth').touched && taxInfoForm.get('netWealth').invalid}"
          >
          <div class="invalid-feedback">
            Net Wealth is required
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4">Paid Tax</label>
        <div class="input-group col-8">
          <input placeholder="" formControlName="paidTax" class="form-control" (input)="filterCharacter($event,'paidTax')"
            [ngClass]="{'is-invalid': taxInfoForm.get('paidTax').touched && taxInfoForm.get('paidTax').invalid}"
          >
          <div class="invalid-feedback">
            Paid Tax is required
          </div>
        </div>
      </div>
      <div *ngIf="status != 'approved'" class="form-group row">
        <label class="col-4">Return Register Serial Number</label>
        <div class="input-group col-8">
          <input placeholder="" formControlName="returnRegSerial" class="form-control"
            [ngClass]="{'is-invalid': taxInfoForm.get('returnRegSerial').touched && taxInfoForm.get('returnRegSerial').invalid}"
          >
          <div class="invalid-feedback">
           Return register serial number is required
          </div>
        </div>
      </div>
      <div *ngIf="status != 'approved'" class="form-group row">
        <label class="col-4">Submission Date</label>
        <div class="input-group col-8">
          <input type="text" class="form-control" placeholder=""
              formControlName="submissionDate"
              aria-label="Submission Date" aria-describedby="button-addon2"
              bsDatepicker #submitDate="bsDatepicker" [maxDate]="maxDate" [minDate]="minDate"
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue'}"
              [ngClass]="{'is-invalid':taxInfoForm.get('submissionDate').touched && taxInfoForm.get('submissionDate').invalid}">
          <div class="input-group-append">
            <button class="btn btn-outline-info btn-sm" type="button" id="button-addon2"
                (click)="submitDate.toggle()"
            >
                <span class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                </span>
            </button>
          </div>
          <div class="invalid-feedback">
            Submission Date is required
          </div>
        </div>
      </div>
      <div *ngIf="status != 'approved'" class="form-group row">
        <label class="col-4">Submission Section</label>
        <div class="input-group col-8">
          <select class="form-control" formControlName="submissionSection"
                  [ngClass]="{'is-invalid':taxInfoForm.get('submissionSection').touched && taxInfoForm.get('submissionSection').value == '0'}">
              <option value="0">Select</option>
              <option value="180">180 (82BB)</option>
              <option value="180(2)">180(2) (82BB(5))</option>
          </select>
          <div class="invalid-feedback">
            Submission Section is required
          </div>
        </div>
      </div>
      <div *ngIf="status != 'approved'" class="form-group row">
        <label class="col-4">Taxes Submitted Zone</label>
        <div class="input-group col-8">
          <select class="form-control" formControlName="taxZone" (change)="onSelectZone()"
                  [ngClass]="{'is-invalid':taxInfoForm.get('taxZone').touched && taxInfoForm.get('taxZone').value == '0'}">
            <option [value]="0">Select</option>
            <option *ngFor="let zone of taxZones" [value]="zone.zoneNo">{{zone.zoneName}}</option>
          </select>
          <div class="invalid-feedback">
            Taxes submitted zone is required
          </div>
        </div>
      </div>
      <div *ngIf="status != 'approved'" class="form-group row">
        <label class="col-4">Taxes Submitted Circle</label>
        <div class="input-group col-8">
          <select class="form-control" formControlName="taxCircle"
                  [ngClass]="{'is-invalid':taxInfoForm.get('taxCircle').touched && taxInfoForm.get('taxCircle').value == '0'}">
            <option [value]="0">Select</option>
            <option *ngFor="let circle of taxCircles" [value]="circle?.circleNo">{{circle?.circleName}}</option>
          </select>
          <div class="invalid-feedback">
            Taxes submitted circle is required
          </div>
        </div>
      </div>

      <div class="row mt-5 mb-2">
        <div class="col-12 text-center">
          <button *ngIf="status == 'approved'; else applicationButton" type="submit" class="btn"
              [disabled]="taxInfoForm.get('totalIncome').invalid || taxInfoForm.get('netWealth').invalid || taxInfoForm.get('paidTax').invalid"
              (click)="onRequestCertificate()" style="background-color: #145DA0;color: white; width:200px">
            Request Certificate
          </button>
          <ng-template #applicationButton>
            <button type="submit" class="btn" [disabled]="taxInfoForm.invalid || taxInfoForm.value.submissionSection == '0' || taxInfoForm.value.taxZone == 0 || taxInfoForm.value.taxCircle == 0"
                (click)="onApplyForCertificate()" style="background-color: #145DA0;color: white; width:200px">
              Apply for Certificate
            </button>
          </ng-template>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ngx-ui-loader></ngx-ui-loader>
